var BingMap = BingMap || {};
BingMap.Map = function () {
	//console.log('bingmap-map.js');

	//VARIABLES
	var _log = false,
		imgBaseUrl = '',//"http://www.travelwisconsin.com",
		baseCategory = '',//populated below
		basePath = decodeURIComponent($("[data-basepath]").data("basepath")),
		reportTypeEnum = tw.ConditionsReports.getReportTypeEnum(),
		strYoutubePin = 'YouTube Pin',

		breakPoints = {
			'main': 1024//760
		},
		//isTablet = false,
		isMobile = false, //mobile/desktop only, 760px brkpt
		wasMobile = null,
        
		//general/config
		map = null,
		//IsZoomedOut = true,
		countyData = null,
		reportType = "empty",
		reportSubcode = "",
		baseZoom = 7,
		//tabletZoom = 6.5,//only integers work
		mobileZoom = 6,
		useZoom = null,
		useCenterLocation = null,
		radiusSearch = 30,//was 25

		//layers
		centeringLayer = null,
		countyLayer = null,
		localReportLayer = null,
		youtubePinLayer = null,
		relatedPlacesPinLayer = null,
		isYoutubePinLayerVisible = true,
		isPOIPinLayerVisible = true,
		isTrailPOIPinLayerVisible = true,
		partialCounties = "",
		reportInfoBoxArray = Array(),
		photoInfoBoxArray = Array(),
		youtubeInfoBoxArray = Array(),
		POIInfoBoxArray = Array(),

		//location
		desktopCenter = null,
		tabletLandscapeCenter = null,
		tabletPortraitCenter = null,
		mobileCenter = null,
		centerLocation = null,
		mouseStartX = null,
		mouseStartY = null,
		mapX = null,
		mapY = null,
		point_wi_tl = null,
		point_wi_br = null,
		wiBounds = null,
		openId = "";
        
	/**
	 * Class: GPS Point
	 */
	var GPSPoint = function (obj) {
		this.latitude = obj.latitude;
		this.longitude = obj.longitude;
		//if (_log) console.log('new GPSPoint: ', this);
	},
	/**
	 * Class: Dimensions
	 */
	Dimensions = function (obj) {
		this.width = obj.width;
		this.height = obj.height;
		//if (_log) console.log('new:', this);
	};


	//TEMPLATES
	var mapInfoboxFCRTemplate = $('#mapInfoboxFCRTemplate').html(),
		mapInfoboxSCRTemplate = $('#mapInfoboxSCRTemplate').html(),
		mapInfoboxTrailTemplate = $('#mapInfoboxTrailTemplate').html(),
		mapThumbTemplate = $('#mapThumbTemplate').html(),
		pinInfoboxFCRTemplate = $('#pinInfoboxFCRTemplate').html(),
		pinInfoboxTrailTemplate = $('#pinInfoboxTrailTemplate').html(),
		preloaderTemplate = $('#preloaderTemplate').html(),
		preloaderMapTemplate = $('#preloaderMapTemplate').html();


	//MAP OPTIONS
	var mapOptions = {
		//credentials: "At8Jkh0rmaGv5-mCIc6Q_2mia5ADadap_rZvH_waQYEREGWL1mBCQxegKjJ88U2x",//DEPRECATED
		zoom: baseZoom,
		center: centerLocation,
		enableSearchLogo: false,
		showScalebar: false,
		showDashboard: false,
		useInertia: false,
		disableKeyboardInput: true,
		disablePanning: false, //mobile.matches, // - remove all panning for MOBILE ONLY except when using the compass buttons
		liteMode: true
	};


	/**
	 * Get if map is initialized yet
	 */
	var getMapInit = function () {
		return map;
	};

	/**
	 * Initialize Buttons
	 */
	var initializeButtons = function () {

		//Map Controls
		$('#zoomIn').on('click', function () {
			zoomMap('+');
		});
		$('#zoomOut').click('click', function () {
			zoomMap('-');
		});
		$('#resetMap').click('click', function () {
			softResetMap();
			tw.ConditionsReports.resetAllPanes();
		});
		$('#toggleYoutube').click('click', function () {
			if (isYoutubePinLayerVisible) {
				$(this).removeClass('is-active');
			} else {
				$(this).addClass('is-active');
			}
			toggleYoutube();
		});
		$('#togglePOI').click('click', function () {
			if (isPOIPinLayerVisible) {
				$(this).removeClass('is-active');
			} else {
				$(this).addClass('is-active');
			}
			togglePOI();
		});
		$('#toggleTrailPOI').click('click', function () {
			if (isTrailPOIPinLayerVisible) {
				$(this).removeClass('is-active');
			} else {
				$(this).addClass('is-active');
			}
			toggleTrailPOI();
		});
	};



	var checkReportType = function () {
		if (_log) console.group('tw.BingMap.Map.checkReportType().reportType:', reportType);
		baseCategory = tw.ConditionsReports.getBaseCategory();

		// switch(reportType) {
		// 	case reportTypeEnum.trail:
		// 		baseCategory = 'Biking Report';
		// 		break;
		// 	case reportTypeEnum.fallcolor:
		// 		baseCategory = 'Fall Color Report';
		// 		break;
		// 	default:
		// 		baseCategory = 'Snow Conditions Report';
		// }
		if (_log) console.log('baseCategory:', baseCategory);
	}




	/**
	 * (RE)initializeMap Microsoft map functionality AFTER bing maps library is loaded, will be triggered via callback > index.js > map.js
	 */
	var initializeMap = function (config) {
		if (_log) console.group('BingMap.Map.initializeMap()', config);
		if (_log) console.log('config:', config);

		countyData = config.CountyData;
		reportType = config.ReportType;
		reportSubcode = config.ReportSubcode;

		if (_log) console.log('reportType:', reportType);
		if (_log) console.log('reportSubcode:', reportSubcode);
		if (_log) console.log('baseCategory:', baseCategory);

		checkReportType();

		//console.log("$('.js-preloader.map').width()" + $('.js-preloader.map').width());
		if ($('.js-preloader').length === 0) {
			addPreloaderMap();
		}

		reportInfoBoxArray = [];
		youtubeInfoBoxArray = [];
		POIInfoBoxArray = [];

		desktopCenter = new Microsoft.Maps.Location(45.205852, -92.03011); //(YY, XX)//44.505852, -92.03011
		tabletLandscapeCenter = new Microsoft.Maps.Location(44.43739, -91.84382);
		tabletPortraitCenter = new Microsoft.Maps.Location(44.73739, -88.8);
		mobileCenter = new Microsoft.Maps.Location(44.80282, -90.07542);//44.80282, -90.07542
		centerLocation = desktopCenter; // start with desktop

		centeringLayer = new Microsoft.Maps.Layer();
		countyLayer = new Microsoft.Maps.EntityCollection();
		localReportLayer = new Microsoft.Maps.EntityCollection();
		localReportLayer.LayerName = "LocalReports";

		youtubePinLayer = new Microsoft.Maps.EntityCollection();
		youtubePinLayer.setOptions({ zIndex: 9999, visible: true });
		youtubePinLayer.LayerName = "YoutubePinLayer";

		relatedPlacesPinLayer = new Microsoft.Maps.EntityCollection();
		relatedPlacesPinLayer.setOptions({ zIndex: 9999, visible: true });
		relatedPlacesPinLayer.LayerName = "YoutubePinLayer";
		
		//(TL:YY, TL:XX, BR:YY, BR:XX)
		//48.882830, -99.858254, 42.131071, -80.932511 //4x3ratio
		wiBounds = Microsoft.Maps.LocationRect.fromEdges(53.882830, -104.858254, 37.131071, -75.932511); 


		trackResize(); //get initial window dims, set presets


		mapOptions = {
			mapTypeId: Microsoft.Maps.MapTypeId.grayscale, //aerial,//canvasDark//grayscale
			minZoom: 5,
			maxBounds: wiBounds,
			zoom: useZoom,//baseZoom,
			center: useCenterLocation,//centerLocation,
			enableSearchLogo: false,
			showScalebar: false,
			showDashboard: false,
			useInertia: false,
			disableKeyboardInput: true,
			disablePanning: false, //mobile.matches, // - remove all panning for MOBILE ONLY except when using the compass buttons
			liteMode: true
		};
		if (_log) console.log('mapOptions:', mapOptions);

		map = new Microsoft.Maps.Map('#map', mapOptions);
		map.entities.clear();

		Microsoft.Maps.loadModule('Microsoft.Maps.AdvancedShapes', {
			callback: getCountiesPercentPeak
		});
		Centering.init();

		if (_log) console.groupEnd();
	}



	/**
	 * Recalculate zoom upon init/resize
	 */
	var recalculateZoom = function () {
		if (_log) console.group('recalculateZoom()');
		if (isMobile) {// || isTablet
			useZoom = mobileZoom;
			useCenterLocation = mobileCenter;
		} else {
			useZoom = baseZoom;
			useCenterLocation = desktopCenter;
		}

		
		if (_log) console.log('isMobile', isMobile);
		if (_log) console.log('useZoom', useZoom);
		if (_log) console.log('useCenterLocation', useCenterLocation);
		
		if (map != null) {
			map.setView({
				zoom: useZoom,
				center: useCenterLocation
			});
		}
		if (_log) console.groupEnd();
		
	};


	/**
	 * Allow index.js to update reporttype here
	 */
	var updateReportType = function (type) {
		reportType = type;
		//if (_log) console.log('updateReportType.reportType:', reportType);
	}

	/**
	 * Soft reset map.
	 * for use when map is centered/zoomed on local reports, zoom out to initial state and clear infoxboxes and cetering ring.
	 */
	var softResetMap = function () {
		if (_log) console.group('softResetMap()');

		deleteReportInfoBoxes();
		deletePhotoInfoboxes();

		centeringLayer.clear();
		map.entities.remove(centeringLayer);
		Centering.Reset();

		map.setView({
			zoom: useZoom,
			center: useCenterLocation
		});

		//reset pane
		// if (!$('.js-reports-status-toggle').hasClass('active')) {
		// 	//tw.ConditionsReports.updateReportsStatusToggle();
		// }
		tw.ConditionReportsListings.emptyReportDetails();
		tw.ConditionReportsListings.emptyLocalReports();
		if (_log) console.groupEnd();
	}


	/**
	 * toggle youtube drone layer
	 */
	var toggleYoutube = function () {
		if (_log) console.group('toggleYoutube()');
		//if (_log) console.log('isYoutubePinLayerVisible.was:', isYoutubePinLayerVisible);
		isYoutubePinLayerVisible = !isYoutubePinLayerVisible;
		if (_log) console.log('isYoutubePinLayerVisible.now:', isYoutubePinLayerVisible);

		for (var i = 0; i < youtubeInfoBoxArray.length; i++) {
			//console.log(i, youtubeInfoBoxArray[i]);
			youtubeInfoBoxArray[i].setOptions({visible: isYoutubePinLayerVisible})
		} 

		if (_log) console.groupEnd();
	}

	/**
	 * toggle POI drone layer
	 */
	var togglePOI = function () {
		if (_log) console.group('togglePOI()');
		//if (_log) console.log('isPOIPinLayerVisible.was:', isPOIPinLayerVisible);
		isPOIPinLayerVisible = !isPOIPinLayerVisible;
		if (_log) console.log('isPOIPinLayerVisible.now:', isPOIPinLayerVisible);

		for (var i = 0; i < POIInfoBoxArray.length; i++) {
			//console.log(i, POIInfoBoxArray[i]);
			POIInfoBoxArray[i].setOptions({visible: isPOIPinLayerVisible})
		} 

		if (_log) console.groupEnd();
	}

	var toggleTrailPOI = function () {
		if (_log) console.group('toggleTrailPOI()');
		if (_log) console.log('isTrailPOIPinLayerVisible.was:', isTrailPOIPinLayerVisible);
		isTrailPOIPinLayerVisible = !isTrailPOIPinLayerVisible;
		if (_log) console.log('isTrailPOIPinLayerVisible.now:', isTrailPOIPinLayerVisible);

		for (var i = 0; i < TrailPOIInfoBoxArray.length; i++) {
			if (_log) console.log(i, TrailPOIInfoBoxArray[i]);
			TrailPOIInfoBoxArray[i].setOptions({ visible: isTrailPOIPinLayerVisible })
		}

		if (_log) console.groupEnd();
	}



	//BINGMAP AJAX GETTERS

	/**
	 * Get Counties Percent Peak
	 */
	var getCountiesPercentPeak = function () {
		//var reportSubcode = tw.ConditionsReports.getReportSubcode();
		if (_log) console.log('getCountiesPercentPeak()', reportType, reportSubcode);
		if (reportType == reportTypeEnum.snowmobile || reportType == reportTypeEnum.downhill) {
			$.ajax({
				url: basePath + '/getallpartiallyclosedcounties?reportType='+reportType,
				type: "POST",
				async: false,
				success: function (data) {
					partialCounties = data;
				},
				error: function (xhr, status, error) {
					console.log(xhr, status, error);
				}//,
				// complete: function () {
				// 	//console.log('getallpartiallyclosedcounties.complete');
				// }
			});
		}

		$.ajax({
			url: basePath + '/getallcountiespercentpeak',
			data: {
				"reportType": reportType,
				"subcodeName": reportSubcode
			},
			type: "GET",
			success: function (data) {
				if (_log) console.log('ConditionsReportsMap.getCountiesPercentPeak()', data);
				addCounties(data);
			},
			error: function (xhr, status, error) {
				console.log(xhr, status, error);
			}//,
			// complete: function () {
			// 	//if (_log) console.log('getCountiesPercentPeak.complete');
			// }
		});
	};




	/**
	 * Get Pin Reports & getLocalReports
	 * @param {*} reportLayer 
	 * @param {*} region 
	 * @param {*} location 
	 * @param {*} callback 
	 */
	var getPinReports = function (reportLayer, region, location) {
		if (_log) console.group('getPinReports()');
		if (_log) console.log('reportLayer:', reportLayer);
		if (_log) console.log('region:', region);
		if (_log) console.log('location:', location);

		var compiledTemplate = Template7.compile(preloaderTemplate),
			htmlPreloader = compiledTemplate();
		$('#reportsLocal').html(htmlPreloader);


		$.ajax({
			url: basePath + '/report',//localReports
			type: "POST",
			data: {
				"type": reportType,
				"region": region,
				"location": location,
				"subcodeName": reportSubcode
			},
			success: function (data) {
				if (_log) console.log('getPinReports.data:', data);
				tw.ConditionReportsListings.addLocalReports(data, reportType);//keep before addPinReportsToLayer
				addPinReportsToLayer(data, reportLayer, region, location); 
			},
			error: function (xhr, status, error) {
				console.log(xhr, status, error);
			}//,
			// complete: function () {
			// 	//if (_log) console.log('getPinReports.complete()');
			// }
		});
		if (_log) console.groupEnd();
	};



	var getYoutubePinLocations = function () {
		if (_log) console.log('getYoutubePinLocations()');
		$.ajax({
			url: basePath + '/getYoutubePinLocations',//drones
			type: "POST",
			success: function (data) {
				if (_log) console.log('getYoutubePinLocations.data:', data);
				addYoutubePinLocations(data);
			},
			error: function (xhr, status, error) {
				console.log(xhr, status, error);
			}
		});
	}

	var getTrailYoutubePinLocations = function () {
		if (_log) console.log('getTrailYoutubePinLocations()');
		$.ajax({
			url: basePath + '/getTrailYoutubePinLocations',
			data: {
				"subcodeName": reportSubcode
			},
			type: "POST",
			success: function (data) {
				if (_log) console.log('getTrailYoutubePinLocations.data:', data);
				addYoutubePinLocations(data);
			},
			error: function (xhr, status, error) {
				console.log(xhr, status, error);
			}
		});
	}

	var getPOIPinLocations = function () {
		if (_log) console.log('getPOIPinLocations()');
		$.ajax({
			url: basePath + '/getPOIPinLocations',
			type: "POST",
			success: function (data) {
				if (_log) console.log('getPOIPinLocations.data:', data);
				addRelatedPlacesLocations(data);
			},
			error: function (xhr, status, error) {
				console.log(xhr, status, error);
			}
		});
	}

	// Gets POI pins based on the subcode name (either 'hiking' or 'biking')
	var getTrailPOIPinLocations = function () {
		if (_log) console.log('getTrailPOIPinLocations()');
		$.ajax({
			url: basePath + '/getTrailPOIPinLocations',
			data: {
				/*"reportType": reportType,*/
				"subcodeName": reportSubcode
			},
			type: "POST",
			success: function (data) {
				if (_log) console.log('getTrailPOIPinLocations.data:', data);
				addRelatedPlacesLocations(data);
			},
			error: function (xhr, status, error) {
				console.log(xhr, status, error);
			}
		});
	}



	//BINGMAP DECORATE STAGE


	var addYoutubePinLocations = function (data){
		if (_log) console.log('addYoutubePinLocations()', data);
		
		if(youtubePinLayer) youtubePinLayer.clear();

		var ytMapInt = setInterval(function () {
			if(map) {
				try {
					map.entities.remove(youtubePinLayer);
					map.layers.insert(youtubePinLayer);
				} catch (ex) {
					console.error(ex);
				}
		
				for (var i = 0; i < data.length; i ++) {
					data[i].Count = i;
					var location = "" + data[i].Latitude + "," + data[i].Longitude + "";
					infoboxPinPlacement(data[i], location);
					//youtubePinLayer.push(infoboxPinPlacement(data[i], location));
				}
				clearInterval(ytMapInt);
			}
		}, 300);


	}

	var addRelatedPlacesLocations = function (data) {
		if (_log) console.log('addRelatedPlacesLocations()', data);
		if (relatedPlacesPinLayer) relatedPlacesPinLayer.clear();
	
		var rpMapInt = setInterval(function () {
			if (map) {
				try {
					map.entities.remove(relatedPlacesPinLayer);
					map.layers.insert(relatedPlacesPinLayer);
				} catch (ex) {
					console.error(ex);
				}
				for (var i = 0; i < data.length; i++) {
					data[i].Count = i;
					
					// Check if RelatedPlaces exist and have more than one place
					if (data[i].RelatedPlaces && data[i].RelatedPlaces.length > 0) {
						var firstRelatedPlace = data[i].RelatedPlaces[0];
						//if (_log) console.log('firstRelatedPlace:', firstRelatedPlace);
						var headerImage = firstRelatedPlace.Media && firstRelatedPlace.Media.length > 0
						? firstRelatedPlace.Media[0].FileLocationWithoutTilde
						: '';

						var newDataObject = {
							ID: data[i].Count,
							AddressFormatted: firstRelatedPlace.AddressFormatted,
							Count: data[i].Count,
							City: firstRelatedPlace.City,
							Description: firstRelatedPlace.Content,
							HeaderImage: headerImage,
							Latitude: parseFloat(firstRelatedPlace.Lat.Value),
							Longitude: parseFloat(firstRelatedPlace.Long.Value),
							PercentToPeak: data[i].PercentToPeak,
							RelatedLocation: true,
							State: firstRelatedPlace.State,
							Title: firstRelatedPlace.Name,
							Url: firstRelatedPlace.Url,
							Website: firstRelatedPlace.Website
						};

						var location = firstRelatedPlace.Lat.Value + "," + firstRelatedPlace.Long.Value;

						infoboxPinPlacement(newDataObject, location);
					}	
				}
				clearInterval(rpMapInt);
			}
		}, 300);	
	};


	/**
	 * Add Counties Geometry polygons to stage, attach handlers
	 * @param {*} data 
	 */
	var addCounties = function (data) {
		if (_log) console.group('ConditionsReportsMap.addCounties()', data);
		if (_log) console.log('reportType:', reportType);

		countyLayer.LayerName = "Counties";
		var percentData = data;
		for (var i = 0; i < countyData.length; i++) { //countyData.length
			var feature = countyData[i];
			var geometry = feature.Value;

			var percentPeak = 0.0;
			var color;
			percentPeak = jQuery.grep(percentData, function (d) {
				return (d.Key == feature.Key);
			})[0];

			var mOpacity = .75; //decimal value between 0 and 1. If a value between 1 and 255 is specified, as was done in Bing Maps V7, it will be divided by 255.

			if (reportType == reportTypeEnum.trail) {
				if (typeof percentPeak === "undefined") {
					color = new Microsoft.Maps.Color(mOpacity, 255, 255, 255);
				} else if (percentPeak.Value < 0) {
					color = new Microsoft.Maps.Color(mOpacity, 255, 255, 255);
				} else if (percentPeak.Value <= 25) {
					color = new Microsoft.Maps.Color(mOpacity, 123, 119, 116);//#7b7774;//closed
				} else if (percentPeak.Value <= 50) {
					color = new Microsoft.Maps.Color(mOpacity, 36, 55, 9);//#243709;//poor
				} else if (percentPeak.Value <= 75) {
					color = new Microsoft.Maps.Color(mOpacity, 72, 110, 18);//#486E12;//fair
				} else if (percentPeak.Value <= 100) {
					color = new Microsoft.Maps.Color(mOpacity, 111, 194, 29);//#6FC21D;//good
				} else {
					color = new Microsoft.Maps.Color(mOpacity, 111, 194, 29);//#6FC21D;//good
				}
			} else if (reportType == reportTypeEnum.fallcolor) {
				if (typeof percentPeak === "undefined") {
					color = new Microsoft.Maps.Color(mOpacity, 176, 16, 16);//new maroon//b01010
				} else if (percentPeak.Value < 0) {
					color = new Microsoft.Maps.Color(mOpacity, 176, 16, 16);//new maroon//b01010
				} else if (percentPeak.Value <= 25) {
					color = new Microsoft.Maps.Color(mOpacity, 143, 172, 27);//green//8FAC1B
				} else if (percentPeak.Value <= 50) {
					color = new Microsoft.Maps.Color(mOpacity, 255, 177, 0);//yellow//#ffb100
				} else if (percentPeak.Value <= 75) {
					color = new Microsoft.Maps.Color(mOpacity, 247, 113, 0);//orange//#f77100
				} else if (percentPeak.Value <= 100) {
					color = new Microsoft.Maps.Color(mOpacity, 228, 31, 0);//red//#e41f00
				} else if (percentPeak.Value <= 105) {
					color = new Microsoft.Maps.Color(mOpacity, 176, 16, 16);//new maroon//b01010
				} else if (percentPeak.Value > 105) {
					color = new Microsoft.Maps.Color(mOpacity, 78, 8, 14);//brown//4e808e
                }
			} else {
				if (typeof percentPeak === "undefined") {
					color = new Microsoft.Maps.Color(mOpacity, 255, 255, 255);
				} else if ((reportType == reportTypeEnum.snowmobile || reportType == reportTypeEnum.downhill) && jQuery.inArray(feature.Key, partialCounties) >= 0) {					
					color = new Microsoft.Maps.Color(mOpacity, 185, 184, 185);//idk what this is for
				} else if (percentPeak.Value <= 0) {
					color = new Microsoft.Maps.Color(mOpacity, 104, 100, 97);
				} else if (percentPeak.Value <= 25) {
					color = new Microsoft.Maps.Color(mOpacity, 199, 232, 234);//poor//c7e8ea
				} else if (percentPeak.Value <= 50) {
					color = new Microsoft.Maps.Color(mOpacity, 133, 209, 212);//fair//85d1d4
				} else if (percentPeak.Value <= 75) {
					color = new Microsoft.Maps.Color(mOpacity, 48, 146, 168);//good//3092a8
				} else if (percentPeak.Value <= 100) {
					color = new Microsoft.Maps.Color(mOpacity, 0, 77, 113);//excellent//004d71
				} else {
					color = new Microsoft.Maps.Color(mOpacity, 255, 255, 255);
				}
			}

			$.each(geometry, function (index, poly) {
				// draw only the first (exterior) polygon
				var locations = [];
				$.each(poly[0], function (cindex, coord) {
					var location = new Microsoft.Maps.Location(coord[0], coord[1]);
					locations.push(location);
				});
				var polygon = new Microsoft.Maps.Polygon(locations, {
					fillColor: color,
					strokeColor: new Microsoft.Maps.Color(mOpacity, 0, 0, 0),
					strokeThickness: parseFloat(0.5),
					name: feature.Key
				});

				polygon.Name = feature.Key;
				Microsoft.Maps.Events.addHandler(polygon, 'click', BingMap.Map.mouseHandler);
				Microsoft.Maps.Events.addHandler(polygon, 'mousedown', BingMap.Map.mouseHandler);
				Microsoft.Maps.Events.addHandler(polygon, 'mouseup', BingMap.Map.mouseHandler);
				countyLayer.push(polygon);

			});

		}

		if (_log) console.groupEnd();

		map.layers.insert(countyLayer);

		//unload preloader
				$('.js-preloader').remove();
				tw.ConditionsReports.openPane();
	}

	/**
	 * Find Local Information from location
	 * @param {*} location 
	 * @param {*} callback 
	 */
	var findLocalInformation = function (location, callback) {
		if (_log) console.log('findLocalInformation()');

		Centering.SetCenter(location.latitude, location.longitude);
		Centering.SetQueryCenter(location.latitude, location.longitude);

		map.setView({
			zoom: 8,
			center: location
		});
		//IsZoomedOut = false;

		centeringLayer.clear() //doesn't clear data
		map.layers.remove(centeringLayer);
		centeringLayer.LayerName = "Centering";
		centeringLayer.setZIndex(99999);

		//dashed line circle
		//var polyline1 = BingMap.Utilities.drawCircleLineFromLocation(location.latitude, location.longitude, BingMap.Utilities.convertMilesToKilometers(radiusSearch), new Microsoft.Maps.Color(255, 255, 255, 255), 8);
		//center point of circle, red
		var polygon1 = BingMap.Utilities.drawCircleFromLocation(location.latitude, location.longitude, BingMap.Utilities.convertMilesToKilometers(2), new Microsoft.Maps.Color(100, 255, 0, 0), new Microsoft.Maps.Color(0, 255, 255, 255), 0); //no stroke
		//main circle and outer stroke
		var polygon2 = BingMap.Utilities.drawCircleFromLocation(location.latitude, location.longitude, BingMap.Utilities.convertMilesToKilometers(radiusSearch), new Microsoft.Maps.Color(100, 0, 0, 0), new Microsoft.Maps.Color(1, 255, 255, 255), 3);

		centeringLayer.add(polygon2);
		centeringLayer.add(polygon1);

		map.layers.insert(centeringLayer);

		localReportLayer.clear();
		try {
			map.entities.remove(localReportLayer);
		} catch (ex) {

		}
		map.layers.insert(localReportLayer);
		if (reportType == reportTypeEnum.fallcolor) {
			$('.js-pane-header').addClass('hidden');
		}		

		getPinReports(localReportLayer, null, Centering.QueryCenterPoint());

	};



	var deleteReportInfoBoxes = function () {
		if (_log) console.log('deleteReportInfoBoxes()');
		if (_log) console.log('reportInfoBoxArray.before..', reportInfoBoxArray);
		for (var i = 0; i < reportInfoBoxArray.length; i++) {
			//console.log(i, reportInfoBoxArray[i]);
			reportInfoBoxArray[i].setMap(null);
			//console.log('cleared');
		}

		reportInfoBoxArray = [];
		if (_log) console.log('reportInfoBoxArray.clearout', reportInfoBoxArray);
	}


	/**
	 * Add Pin Reports to Layer
	 * @param {*} data 
	 * @param {*} reportLayer 
	 * @param {*} region 
	 * @param {*} location 
	*/
	var addPinReportsToLayer = function (data, reportLayer, region, location) {
		if (_log) console.group('addPinReportsToLayer()');
		if (_log) console.log('data', data);
		// if (_log) console.log('data.length', data.length);
		// if (_log) console.log('reportLayer', reportLayer);
		// if (_log) console.log('region', region);
		if (_log) console.log('location', location);

		deleteReportInfoBoxes();

		for (var i = 0; i < data.length; i++) {
			data[i].Count = (i + 1);
			var isYoutubePin = (data[i].State == strYoutubePin || data[i].Condition == strYoutubePin) ? true : false;
			// console.log(isYoutubePin, 'isYoutubePinisYoutubePin');
			if(!isYoutubePin) var infoBox = infoboxPinPlacement(data[i], location);

		}

		if (_log) console.log('openId.1:', openId);
		if (openId != "" && openId > 0) {
			infoBoxExpand(openId);
			openId = "";
		}

		reportLayer.setOptions({
			zIndex: 99999999999,
			visible: true
		});

		map.layers.insert(reportLayer);
		if (_log) console.groupEnd();
	}

	/**
	 * infobox Photo Pin Placement
	 * @param {*} data 
	 * @param {*} location 
	 */
	var infoboxPhotoPinPlacement = function (data) {
		if (_log) console.log('infoboxPhotoPinPlacement()', data);

		var compiledTemplate = Template7.compile(mapThumbTemplate);

		var infoboxOptions = {
			width: 270,
			height: 35,
			zIndex: 1,
			id: data.Title,
			offset: new Microsoft.Maps.Point(-13, 0)
		};
		var pinLocation = new Microsoft.Maps.Location(data.Latitude, data.Longitude);
		var photoInfobox = new Microsoft.Maps.Infobox(pinLocation, infoboxOptions);

		var jsonContent = {
			Id: data.ID,
			Latitude: data.Latitude,
			Longitude: data.Longitude,
			ImageSrc: imgBaseUrl + data.ImageSrc
		};
		//if (_log) console.log('jsonContent:', jsonContent);

		var html = compiledTemplate(jsonContent);

		photoInfobox.setHtmlContent(html);
		photoInfobox.setMap(map);

		Microsoft.Maps.Events.addHandler(photoInfobox, 'click', function () {
			deletePhotoInfoboxes();
		});

		photoInfoBoxArray.push(photoInfobox);
		return photoInfobox;
	}

	/**
	 * Remove all PHoto infoboxes from stage
	 */
	var deletePhotoInfoboxes = function () {
		//if (_log) console.log('deletePhotoInfoboxes()');
		//console.log('photoInfoBoxArray:', photoInfoBoxArray);
		for (var i = 0; i < photoInfoBoxArray.length; i++) {
			//console.log(i, photoInfoBoxArray[i]);
			photoInfoBoxArray[i].setMap(null);
		}
		photoInfoBoxArray = [];
	}


	/**
	 * Get Condition base from ConditionClass
	 */
	var getConditionBase = function (color) {
		//if (_log) console.log('getConditionBase.color.in', color);
		switch (color) {
			case "Poor-Partially-Open":
				color = "Poor";
				break;
			case "Fair-Partially-Open":
				color = "Fair";
				break;
			case "Good-Partially-Open":
				color = "Good";
				break;
			case "Excellent-Partially-Open":
				color = "Excellent";
				break;
			case "Poor-Partially Open":
				color = "Poor";
				break;
			case "Fair-Partially Open":
				color = "Fair";
				break;
			case "Good-Partially Open":
				color = "Good";
				break;
			case "Excellent-Partially Open":
				color = "Excellent";
				break;
			case strYoutubePin:
				color = "youtube";
				break;
			default:
				break;
		}

		//if (_log) console.log('getConditionBase.color.out', color);

		return color;
	}

	/* Convert Fall Color Percentages into Colors */
	var getFallColorClass = function (percent) {
        var fallColor = 'green';
		if (percent == -1) {
			fallColor = 'selfie'; //selfie
		} else if (percent == -2) {
			fallColor = 'youtube'; //youtube video
		} else if (percent == -87) {
			fallColor = 'scavenger'; //scavenger
		} else if (percent <= 25) {
			fallColor = 'green'; //'rgba(0, 100, 0)';
		} else if (percent <= 50) {
			fallColor = 'yellow';  //'rgba(255, 185, 15)';
		} else if (percent <= 75) {
			fallColor = 'orange'; //'rgba(238, 118, 0)';
		} else if (percent <= 100) {
			fallColor = 'red'; //'rgba(205, 0, 0)';
		} else if (percent <= 105) {
			fallColor = 'maroon'; //105 is fading/past peak
		} else if (percent > 105) {
			fallColor = 'brown'; //110 is next year
        }
		//if (_log) console.log('getFallColorClass ' +  percent + ' -> ' + fallColor);

		return fallColor;
	}

	/**
	 * Infobox Pin Placement
	 * @param {*} data 
	 * @param {*} location 
	 */
	var infoboxPinPlacement = function (data, location) {
		//if (_log) console.group('infoboxPinPlacement()');
		// console.log('infoboxPinPlacementdata:', data);
		// console.log('location:', location);
	
		if (isNaN(data.Latitude) || isNaN(data.Longitude)) {
			console.error('Invalid latitude or longitude:', data.Longitude, data.Longitude);
			if (_log) console.groupEnd();
			return null;
		}

		var useTemplate;
		switch(reportType) {
			case reportTypeEnum.trail:
				useTemplate = mapInfoboxTrailTemplate;
				break;
			case reportTypeEnum.fallcolor:
				useTemplate = mapInfoboxFCRTemplate;
				break;
			default:
				useTemplate = mapInfoboxSCRTemplate;
		}

		var compiledTemplate = Template7.compile(useTemplate);

		var isYoutubePin = (data.State == strYoutubePin || data.Condition == strYoutubePin) ? true : false;
		//if (_log) console.log('isYoutubePin:', isYoutubePin);

		var infoboxOptions;
		//drone is -2
		if (data.PercentToPeak >= -2) {
			if (isMobile === true) {
				infoboxOptions = {
					width: 39,//keep up to date with _infobox.scss line ~208
					height: 52,
					zIndex: 1,
					id: data.Title,
					offset: new Microsoft.Maps.Point(0, 0)
				};
			} else {
				infoboxOptions = {
					width: 26,//keep up to date with _infobox.scss line ~208
					height: 35,
					zIndex: 1,
					id: data.Title,
					offset: new Microsoft.Maps.Point(0, 0)
				};
			}
			
		} else {
			infoboxOptions = {
				width: 30,
				height: 35,
				zIndex: 1,
				id: data.Title,
				offset: new Microsoft.Maps.Point(-13, 0)
			};
		}
		
		var pinLocation = new Microsoft.Maps.Location(data.Latitude, data.Longitude);
		var defaultInfobox = new Microsoft.Maps.Infobox(pinLocation, infoboxOptions);
		var status = data.State;
		var IsOpenClass = data.IsOpen ? 'Open' : 'Closed';
		if(data.IsOpenWinterFatBiking) {
			IsOpenClass = 'winterfat';
		}

		var color = 'No-Report'; //'rgba(139, 69, 19)';

		if(reportType == reportTypeEnum.trail) {
			if (data.PercentToPeak < 50) {
				color = 'Poor'; //'rgba(0, 100, 0)';
			} else if (data.PercentToPeak < 75) {
				color = 'Fair'; //'rgba(255, 185, 15)';
			} else if (data.PercentToPeak < 101) {
				color = 'Good';
			}
		} else {
			if (data.PercentToPeak < 25) {
				color = 'Poor'; //'rgba(0, 100, 0)';
			} else if (data.PercentToPeak < 50) {
				color = 'Fair'; //'rgba(255, 185, 15)';
			} else if (data.PercentToPeak < 75) {
				color = 'Good'; //'rgba(238, 118, 0)';
			} else if (data.PercentToPeak < 101) {
				color = 'Excellent'; //'rgba(205, 0, 0)';
			}
		}

		var useYoutubeId = '';
		if(data.YoutubeId) {//FCR
			useYoutubeId = data.YoutubeId;
		}else if (data.YouTubeId) {//SCR
			useYoutubeId = data.YouTubeId;
		}


		if (status == "Partially Open") {
			status = "Partial";
		}

		var jsonContent = {
			Color: color,
			Condition: data.Condition,
			ConditionClass: isYoutubePin ? 'youtube' : getConditionBase(data.ConditionClass),
			//FallColor: getFallColorClass(data.PercentToPeak),
			Count: data.Count,
			Description: data.Description,
			IsOpenClass: IsOpenClass,
			IsOpen: data.IsOpen,
			IsYoutubePin: isYoutubePin,
			ID: data.ID,
			Latitude: data.Latitude,
			Longitude: data.Longitude,
			PercentToPeak: data.PercentToPeak,
			Status: status,
			Title: data.Title,
			RelatedLocation: data.RelatedLocation,
			YoutubeId: useYoutubeId
		};
		if (reportType == reportTypeEnum.fallcolor) jsonContent.FallColor = getFallColorClass(data.PercentToPeak);

		// console.log(jsonContent, 'reportInfoBoxArray.jsonContent:');

		var html = compiledTemplate(jsonContent);

		defaultInfobox.setHtmlContent(html);

		defaultInfobox.setMap(map);
		Microsoft.Maps.Events.addHandler(defaultInfobox, 'click', function () {

			var addReportTypeForSCR = '';
			if (reportType != reportTypeEnum.fallcolor) {
				addReportTypeForSCR = ' - ' + tw.ConditionsReports.getReportTitle('gaShort')
			}

			// console.log(data.PercentToPeak, 'data.PercentToPeak');
			if ((reportTypeEnum.fallcolor && data.PercentToPeak === -2) || (isYoutubePin) && data.YoutubeId != '') {
				//youtube modal pins
				//Data layer - I don't think we need this anymore as it's a duplicate. Leaving in case we do need it. - LG
				/* tw.Analytics.ga4(baseCategory, 'Youtube Click' + addReportTypeForSCR, data.Title);*/
				openModalYoutube(data);
			} else if (reportTypeEnum.fallcolor && data.PercentToPeak === -3 && data.RelatedLocation == true) {
				openRelatedLocationDetail(data)
				showInfobox(data)
				$('.js-pane-header').addClass('hidden');
			} else if(reportTypeEnum.trail && data.RelatedLocation == true) {
				openRelatedLocationDetail(data)
				$('.js-pane-header').addClass('hidden');
				showInfobox(data)
			} else {
				tw.Analytics.ga4(baseCategory, 'Map Click' + addReportTypeForSCR, data.Title);
				infoBoxExpand(data.ID);
			}

		});

		//only push to array if not a negative number: -1 = selfie, -2 = youtube, -87 = scavenger

		if(data.PercentToPeak == -2 || isYoutubePin) {
			youtubeInfoBoxArray.push(defaultInfobox);
		} 
		else if (data.PercentToPeak == -3 || data.RelatedLocation) {
			POIInfoBoxArray.push(defaultInfobox);
		}
		else {
			reportInfoBoxArray.push(defaultInfobox);
		}
		return defaultInfobox;
	};

	/**
	 * Infobox Expand
	 * @param {*} id 
	 */
	var infoBoxExpand = function (id) {
		if (_log) console.group('infoBoxExpand()', id);
		//if (_log) console.log(id + ' vs ' + openId);

		var div = "#infoboxText-" + id,
			span = "#county-" + id,
			count = 20;
		
		var openInt = setInterval(function () {
			// if (_log) console.log('$(' + div + ').width():', $(div).width());

			if ($(div).width() > 2) {//wait for infobox to exist, open report

				$('.js-pane-header').addClass('hidden');
				$('.js-infoboxText.active').removeClass('active');
				$('.infoBoxTextWrapperActive').removeClass('infoBoxTextWrapperActive');
				
				// console.log($(div), '$(div) infoBoxExpand');
				if (!$(div).hasClass('active')) {
					$(div).addClass('active');
					$(div).parent().parent().parent().parent().addClass('infoBoxTextWrapperActive');
					var reportId = $(div).data('id'),
						count = $(div).data('count');
					//if (_log) console.log('reportId1: ', reportId);
					//reportId = $(div).data('id') > 0 ? $(div).data('id') : id;
					//if (_log) console.log('reportId2: ', reportId);
					// if (_log) console.log('count: ', count);
		
					tw.ConditionReportsListings.getReportDetails(reportId, count);
				}
				clearInterval(openInt);
			}
			count --;
			if(count == 0) {
				clearInterval(openInt);
			}

		}, 200);

		if (_log) console.groupEnd();
	}

	/**
	 * Show infobox
	 */
	var showInfobox = function (pinData) {
		deleteReportInfoBoxes();
		var infoboxOptions = {
			width: 100,
			height: 100,
			zIndex: 1,
			id: pinData.Title,
			offset: new Microsoft.Maps.Point(-150, 50)
		};

		var pinLocation = new Microsoft.Maps.Location(pinData.Latitude, pinData.Longitude);
		var pinInfobox = new Microsoft.Maps.Infobox(pinLocation, infoboxOptions);

		var compiledTemplate = Template7.compile(pinInfoboxFCRTemplate);

		var jsonContent = {
			ID: pinData.ID,
			AddressFormatted: pinData.AddressFormatted,
			City: pinData.City,
			State: pinData.State,
			Latitude: pinData.Latitude,
			Longitude: pinData.Longitude,
			HeaderImage: pinData.HeaderImage,
			// Count: data[i].Count,
			Title: pinData.Title,
			// Url: pinData.Url,
			// Website: pinData.Website,
			// PercentToPeak: pinData[1].PercentToPeak,
			RelatedLocation: true
		};

		var htmlInfobox = compiledTemplate(jsonContent);
		pinInfobox.setHtmlContent(htmlInfobox);
		pinInfobox.setMap(map);
		reportInfoBoxArray.push(pinInfobox);

		map.setView({
			zoom: 8,
			center: pinLocation
		});
		// Microsoft.Maps.Events.addHandler(pinInfobox, 'mousedown', mouseHandler);
		// Microsoft.Maps.Events.addHandler(pinInfobox, 'click', mouseHandler);
		// Microsoft.Maps.Events.addHandler(pinInfobox, 'mouseup', mouseHandler);		
	}

	/**
	 * Open Report Detail Related Location
	 * @param {*} data 
	 */
	var openRelatedLocationDetail = function (data) {
		if (_log) console.group('openRelatedLocationDetail()');
		var id = 'infoboxText-' + data.ID;
		// console.log('data', data);
		// console.log('id', id);
		// console.log('$(#', id, ').length', $('#' + id).length);

		if (_log) console.log(data, 'openRelatedLocationDetail');
		var count = data.Count;

		// console.log(count, 'count');
		// console.log(count, 'countgetReportDetails');
		// console.log(reportType, 'reportTypegetReportDetails');
		tw.ConditionReportsListings.addReportDetails(data, count, reportType);
		if (_log) console.groupEnd();
	}


	/**
	 * Open modal for youtube videos
	 * @param {*} data 
	 */
	var openModalYoutube = function (data) {
		if (_log) console.group('openModalYoutube()');
		var id = 'infoboxText-' + data.ID;
		if (_log) console.log('data', data);
		if (_log) console.log('id', id);
		if (_log) console.log('$(#', id, ').length', $('#' + id).length);

		$('#' + id).modaal({
			type: 'video',
			start_open: true,
			background: 'rgba(0, 0, 0, 0.8)',
			// before_open: function() {
			// 	console.log('.js-modal-video before_open');
			// 	console.log('.js-modal-video desc', this.$elem.attr('data-modaal-desc'));
			// },
			after_open: function () {
				var captionText = this.$elem.attr('data-modaal-desc');
				var caption = $('<div class="modaal-gallery-label">' + captionText + '</div>');
				$('.modaal-video-wrap').append(caption);
				
			},
			after_close: function () {
				for (var i = 0; i < youtubeInfoBoxArray.length; i++) {
					youtubeInfoBoxArray[i].setOptions({visible: true})
				} 				
			}
		});

		if (_log) console.groupEnd();
	}

	/**
	 * Add icons to map
	 */
	var addDownhillIcons = function (data) {
		if (_log) console.log('addDownhillIcons()', data);
		for (var i = 0; i < data.length; i++) {
			var pushpinOptions = {
				icon: '/images/conditions-reports/snowhill.png?width=39&height=34',
				width: 39,
				height: 34
			};
			var pushpin = new Microsoft.Maps.Pushpin(new Microsoft.Maps.Location(data[i].Latitude, data[i].Longitude), pushpinOptions);

			pushpin.Name = data[i].Title;
			Microsoft.Maps.Events.addHandler(pushpin, 'mousedown', mouseHandler);
			Microsoft.Maps.Events.addHandler(pushpin, 'click', mouseHandler);
			Microsoft.Maps.Events.addHandler(pushpin, 'mouseup', mouseHandler);

			if(!data[i].IsYoutubePin) map.entities.push(pushpin);
			// if (_log) console.log('pushpin', pushpin);

		}
	}

	/**
	 * Add Preloader Map template
	 * LOAD MAP PRELOADER IMMEDIATELY on initial load as soon as the file is ready
	 */
	var addPreloaderMap = function () {
		//if (_log) console.log('addPreloaderMap()');
		var compiledTemplate = Template7.compile(preloaderMapTemplate),
			htmlPreloader = compiledTemplate();
		$('#map').html(htmlPreloader);
	}
	addPreloaderMap();

	/**
	 * Add Photo details to pane and map
	 * @param {*} data - pushed from index.js, getted and stored in JS 
	 */
	var addPhotoDetails = function (data) {
		if (_log) console.log('addPhotoDetails()', data);
	}



	var setOpenId = function (id) {
		openId = id;
		if (_log) console.log("openId is now: " + openId); 
	} 
	
	var getOpenId = function() {
		return openId;
	}


	//BINGMAP LAYERS
	/**
	 * Centering Layer
	 */
	var Centering = function () {
		//if (_log) console.log('Centering()');
		var _isCentered = false;
		var _latitude = 0;
		var _longitude = 0;

		var _qLatitude = 0;
		var _qLongitude = 0;

		var Reset = function () {
			//if (_log) console.log('Centering.Init/Reset()');
			_isCentered = false;
			_latitude = 0;
			_longitude = 0;
			_qLatitude = 0;
			_qLongitude = 0;
		};

		var initialize = function () {
			Reset();
		};

		var SetCenter = function (lat, long) {
			_latitude = lat;
			_longitude = long;
			_isCentered = true;
		};

		var SetQueryCenter = function (lat, long) {
			_qLatitude = lat;
			_qLongitude = long;
			_isCentered = true;
		};

		var IsCentered = function () {
			return _isCentered;
		};

		var CenterPoint = function () {
			return "" + _latitude + "," + _longitude + "";
		};

		var QueryCenterPoint = function () {
			return "" + _qLatitude + "," + _qLongitude + "";
		};

		return {
			init: initialize,
			SetCenter: SetCenter,
			SetQueryCenter: SetQueryCenter,
			Reset: Reset,
			IsCentered: IsCentered,
			CenterPoint: CenterPoint,
			QueryCenterPoint: QueryCenterPoint
		};
	}();




	//BINGMAP ACTIONS

	/**
	 * Handle mouse actions
	 * @param {*} e 
	 */
	var mouseHandler = function (e) {
		if (_log) console.group('mouseHandler()', e);

		if (e.eventName == "mousewheel") {
			var wheelDelta = e.wheelDelta;
			var newZoom = parseInt(map.getZoom());
			if (wheelDelta > 0) {
				++newZoom;
			} else {
				--newZoom;
			}

		} else if (e.eventName == "click" || (e.eventName == "mouseup" && e.isTouchEvent == true)) {
			// if (_log) console.log('mouseStartX:', mouseStartX);
			// if (_log) console.log('mouseStartY:', mouseStartY);
			//apparently click doesn't fire on second tap for ipad iOS 5. using mouse up instead
			if ((mouseStartX == e.getX() && mouseStartY == e.getY()) || (mouseStartX == e.pageX && mouseStartY == e.pageY)) {
				centerZoomGetLocal(e);
				//tw.Iterable.trackEvent({
				//	event: 'mapClick', 
				//	county: e.target.Name,
				//	report: (reportSubcode) ? reportSubcode : reportType
				//});
				// if (e.targetType == 'pushpin') {
				// 	//fire analytics for downhill
				// } else {
				// 	//fire analytics for polygon
				// }
			}
		} else if (e.eventName == "mousedown") {
			mouseStartX = e.pageX;
			mouseStartY = e.pageY;

			mapX = e.getX();
			mapY = e.getY();
		}
		if (_log) console.groupEnd();
	};




	/**
	 * Click on a County shape or Downhill icon
	 * @param {*} e 
	 */
	var centerZoomGetLocal = function (e) {
		if (_log) console.group('centerZoomGetLocal()', e);
		if (_log) console.log('mapX:', mapX);
		if (_log) console.log('mapY:', mapY);

		var point = new Microsoft.Maps.Point(mapX, mapY);
		var location = map.tryPixelToLocation(point);
		if (_log) console.log('location:', location);

		//show new info
		BingMap.Map.showHideLayer('Centering', true);
		findLocalInformation(location);

		var addReportTypeForSCR = '';
		if (reportType != reportTypeEnum.fallcolor) {
			addReportTypeForSCR = ' - ' + tw.ConditionsReports.getReportTitle('gaShort')
		}

		//Data Layer
		tw.Analytics.ga4(baseCategory, 'Map Click' + addReportTypeForSCR, e.target.Name)
		/*console.log('Conditions Reports - Map Click: ', baseCategory, 'Map Click' + addReportTypeForSCR, e.target.Name);*/

		if (_log) console.groupEnd();
	};



	/**
	 * Center and Zoom map
	 */
	var centerZoomMap = function (lat, lng) {
		if (_log) console.log('centerZoomMap():', lat, lng);

		var location = new Microsoft.Maps.Location(lat, lng);
		//if (_log) console.log('centerZoomMap.location:', location);

		//show new info
		BingMap.Map.showHideLayer('Centering', true);
		findLocalInformation(location);

	}



	/**
	 * Zoom Map
	 * @param {*} direction 
	 * @param {*} location 
	 */
	var zoomMap = function (direction, location) {
		if (_log) console.log('zoomMap():', direction, location);

		if (direction === '+') {
			var newZoom = map.getZoom() + 1;
			map.setView({
				zoom: newZoom,
				center: location
			});
		} else if (direction === '-') {
			var newZoom = map.getZoom() - 1;
			map.setView({
				zoom: newZoom,
				center: location
			});
		} else if (typeof direction === 'number') {
			map.setView({
				zoom: direction,
				center: location
			});
		}
		if (_log) console.log('zoomLevel: ', getZoomLevel());
	};

	/**
	 * Get Zoom Level of map
	 */
	var getZoomLevel = function() {
		return map.getZoom();
	};





	/**
	 * Show/Hide Layer
	 * @param {*} layerName 
	 * @param {*} show 
	 */
	var showHideLayer = function (layerName, show) {
		//if (_log) console.log('showHideLayer()', layerName, show);
		var layer = BingMap.Utilities.getLayerByName(layerName, map);

		if (layer) {
			layer.setVisible(true);
		}

	};




	/**
	 * track resize event, update map if needed
	 */
	var trackResize = function () {
		if (_log) console.log('trackResize()');
		BingMap.Utilities.viewportDimensions();

		if (window.innerWidth < breakPoints.main) {
			isMobile = true;
		} else {
			isMobile = false;
		}

		if (wasMobile != isMobile) {
			if (_log) console.log('isMobile changed!!! update map. isMobile:', isMobile);
			wasMobile = isMobile;
			recalculateZoom();
		}
		// if (_log) console.log('wasMobile:', wasMobile);
		// if (_log) console.log('isMobile:', isMobile);
	}



	return {
		addDownhillIcons: addDownhillIcons,
		addPhotoDetails: addPhotoDetails,
		addYoutubePinLocations: addYoutubePinLocations,
		addRelatedPlacesLocations: addRelatedPlacesLocations,
		Centering: Centering,
		centerZoomMap: centerZoomMap,
		deletePhotoInfoboxes: deletePhotoInfoboxes,
		deleteReportInfoBoxes: deleteReportInfoBoxes,
		getConditionBase: getConditionBase,
		getMapInit: getMapInit,
		getOpenId: getOpenId,
		getPOIPinLocations: getPOIPinLocations,
		getTrailPOIPinLocations: getTrailPOIPinLocations,
		getYoutubePinLocations: getYoutubePinLocations,
		getTrailYoutubePinLocations: getTrailYoutubePinLocations,
		infoBoxExpand: infoBoxExpand,
		infoboxPhotoPinPlacement: infoboxPhotoPinPlacement,
		initializeMap: initializeMap,
		initializeButtons: initializeButtons,
		mouseHandler: mouseHandler,
		setOpenId: setOpenId,
		showHideLayer: showHideLayer,
		softResetMap: softResetMap,
		trackResize: trackResize,
		updateReportType: updateReportType,
		getFallColorClass: getFallColorClass
	}

}();